<template>
  <div class="d-flex">
    <v-autocomplete
        :menu-props="{ bottom: true, offsetY: true }"
        class="rounded-lg custom-size block"
        :items="options"
        v-model="item"
        :label="label"
        item-text="name"
        item-value="value"
        :disabled="disabled"
        :multiple="multiple"
        :placeholder="placeholder"
        :return-object="false"
        dense
    />
  </div>
</template>

<script>
export default {
  name: 'StoreSelect',
  props: {
    value: {},
    label: {default: null},
    with_packing: {default: false},
    not_in: {type: Array, default: () => []},
    all_store: {default: false},
    placeholder: {default: null},
    disabled: {default: false},
    passed_stores: {type: Array, default: () => []},
    multiple: {default: false}
  },
  data() {
    return {
      item: null,
      fetchedStores: []
    };
  },
  computed: {
    options() {
      const base = (this.passed_stores && this.passed_stores.length)
          ? this.passed_stores
          : this.fetchedStores;

      return base
          .filter(s => {
            if (!this.not_in.length) return this.with_packing ? true : s.id !== 1;
            const notAllowed = this.not_in.includes(s.id);
            return (this.with_packing ? true : s.id !== 1) && !notAllowed;
          })
          .map(s => ({name: s.name, value: s.id}));
    }
  },
  mounted() {
    if (!this.passed_stores || this.passed_stores.length === 0) {
      this.request({
        url: this.endpoint(`main/store`),
        method: "get",
        success: data => {
          this.fetchedStores = data || [];
        }
      })
    }
    this.setItem();
  },
  methods: {
    setItem() {
      const has = this.options.some(o => o.value === this.value);
      this.item = has ? this.value : null;
    }
  },
  watch: {
    value() {
      this.setItem();
    },
    item() {
      this.$emit("input", this.item);
    },
    passed_stores: {
      handler() {
        this.setItem();
      },
      deep: true
    },
    fetchedStores() {
      this.setItem();
    }
  }
}
</script>

<style scoped>
.custom-size {
  width: 100%;
  height: 40px;
}

.custom-size ::v-deep .v-input__control {
  max-height: 50px !important;
}

.custom-size ::v-deep .v-select__selection {
  font-size: 10px;
}

.custom-size ::v-deep .v-list-item {
  min-height: 30px;
}
</style>
